import $ from 'jquery';

const CLASS_SITE_CONTENT = '.lk-site-content';
const CLASS_SITE = '.lk-site';

let resizeTimer;
let responsiveElementWidth;
let responsiveElement;

const getResponsiveElementWidth = () => {
  if (typeof pageWidth != 'number'){
    if (document.compatMode == 'CSS1Compat'){
      return document.documentElement.clientWidth;
    }
    else {
      return document.body.clientWidth;
    }
  }
};

const getBreakpoint = () => {
  responsiveElementWidth = getResponsiveElementWidth();

  // console.log('responsiveElementWidth', responsiveElementWidth);

  if (responsiveElementWidth >= 1200) {
    // console.log('Breakpoint: lg');
    return 'lg';
  }
  else if (responsiveElementWidth >= 992) {
    // console.log('Breakpoint: md');
    return 'md';
  }
  else if (responsiveElementWidth >= 768) {
    // console.log('Breakpoint: sm');
    return 'sm';
  }
  else {
    // console.log('Breakpoint: xs');
    return 'xs';
  }
};

// Build App Component Functionalities
const isBreakpoint = (breakpoint) => {
  // Bootstrap breakpoints
  // XS: 480px | SM: 768px | MD: 992px | LG: 1200px

  console.log('isBreakpoint Breakpoint: ', getBreakpoint());

  if(breakpoint == getBreakpoint()){
    return true;
  }
  return false;
};

const isNotBreakpoint = (breakpoint) => {
  // Bootstrap breakpoints
  // XS: 480px | SM: 768px | MD: 992px | LG: 1200px

  // console.log('isNotBreakpoint Breakpoint: ', getBreakpoint());

  if(breakpoint != getBreakpoint()){
    return true;
  }
  return false;
};

const helperResponsive = () => {

  // responsiveElement = document.querySelector('.lk-site-footer .container')

  // Event Handler on load
  $(window).on('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

        getBreakpoint();

    }, 250);
  });
};

export {
  helperResponsive,
  getBreakpoint,
  isNotBreakpoint,
  isBreakpoint
};
